import { PDFDownloadLink } from "@react-pdf/renderer";
import ReportPDF from "./RepasseReportPDF"; 
import { getCurrentDateTime } from "../utils/getCurrentDateTime";

const DownloadButton = ({ dataPayments, rawData }) => {
  const currentDateTime = getCurrentDateTime();
  const fileName = `relatorio_medico_solicitante_${currentDateTime}.pdf`;

  return (
    <PDFDownloadLink
      document={<ReportPDF payment={dataPayments} data={rawData || []} />}
      fileName={fileName}>
      {({ loading }) =>
        loading ? "Gerando PDF..." : "Baixar PDF (SOLICITANTE)"
      }
    </PDFDownloadLink>
  );
};

export default DownloadButton;
